import { defineComponent as _defineComponent } from 'vue'
import { useCompanyFeatureComposable } from '@/composables/useCompanyFeatures';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { store } from '@/store/index';
import { dispatchSetUserLocale } from '@/store/main/actionsMain';
import { computed } from 'vue';
import { i18n } from '@/plugins/vue-i18n';
import { useUserComposable } from '@/composables/useUser';
import { RoleId } from '@/lib/enum';
import CompanySwitcher from './CompanySwitcher.vue';

type Page = {
  title: string;
  to?: { name: string };
  href?: string;
  exact: boolean;
  disabled: boolean;
  requiredActiveFeature?: (typeof COMPANY_FEATURES)[keyof typeof COMPANY_FEATURES];
  paidPlanName?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardMenu',
  setup(__props) {

const changeLocale = (locale: string) => {
  dispatchSetUserLocale(store, locale);
};

const m = defineMessages({
  logout: 'ログアウト',
  companySettings: '管理者用設定',
  companyPage: 'テナントページ',
  security: 'セキュリティ設定',
  departments: '部署一覧',
  users: 'ユーザー一覧',
  myPage: 'マイページ',
  periodicExport: '定期エクスポート設定',
  enhancedSecurity: 'セキュリティ強化',
  exportOption: '定期エクスポートオプション',
});

const serviceHelpUrl = process.env.VUE_APP_SERVICE_HELP_DOCUMENT;
// ロケールに基づいて問い合わせページURLを設定
const contactPageUrl = computed(() => {
  return i18n.locale === 'ja-JP'
    ? process.env.VUE_APP_CONTACT_PAGE
    : process.env.VUE_APP_CONTACT_PAGE_EN;
});

const { isFeatureActive, COMPANY_FEATURES, generateInactiveMessage } =
  useCompanyFeatureComposable();
const { user } = useUserComposable();

const pages: Page[] = [
  {
    title: m.companyPage,
    to: { name: 'company' },
    exact: true,
    disabled: false,
  },
  {
    title: m.companySettings,
    to: { name: 'companySettings' },
    exact: true,
    disabled: false,
  },
  {
    title: m.security,
    to: { name: 'ipAddressRestriction' },
    exact: true,
    disabled: user.role_id !== RoleId.USER_ADMIN.value,
    paidPlanName: m.enhancedSecurity,
  },
  {
    title: m.departments,
    to: { name: 'companyDepartments' },
    exact: true,
    disabled: false,
  },
  {
    title: m.users,
    to: { name: 'companyUsers' },
    exact: true,
    disabled: false,
  },
  {
    title: m.myPage,
    to: { name: 'user' },
    exact: true,
    disabled: false,
  },
  {
    title: sharedMessages.tagListLink,
    to: { name: 'companyTags' },
    exact: true,
    disabled: false,
  },
  {
    title: m.periodicExport,
    to: { name: 'companyPeriodicExport' },
    exact: true,
    disabled: false,
    requiredActiveFeature: COMPANY_FEATURES.MANAGE_PERIODIC_EXPORT,
    paidPlanName: m.exportOption,
  },
  {
    title: sharedMessages.sdsDataSpecification,
    href: 'https://file.sdsocr.com/Chemican_Data%20conversion%20specificationsoutlines.pdf',
    exact: true,
    disabled: false,
  },
  {
    title: sharedMessages.supportedLawsList,
    href: 'https://file.sdsocr.com/Chemican_Law%20digitalization%20specifications.pdf',
    exact: true,
    disabled: false,
  },
  {
    title: sharedMessages.knowledgeCenter,
    href: 'https://knowledge.chemican.com/',
    exact: true,
    disabled: false,
  },
];

return { __sfc: true,changeLocale, m, serviceHelpUrl, contactPageUrl, isFeatureActive, COMPANY_FEATURES, generateInactiveMessage, user, pages, sharedMessages, CompanySwitcher }
}

})